import Slider from './slider'
import Slide from './slide'

export { Slide }


export default Slider
